// Scope/handle/team-name token grammar (domain-model §2): mirrors the server's
// internal/domain tokenRe so forms can reject bad names before a round-trip.
// Pure module — node-unit-testable.

export const TOKEN_RE = /^[a-z0-9][a-z0-9_-]*$/;

/**
 * tokenError returns a human hint when value is not a valid token, or null when
 * it is. The empty string is reported as missing rather than malformed.
 */
export function tokenError(value: string): string | null {
  if (value.trim() === "") return "This field is required.";
  if (!TOKEN_RE.test(value)) {
    return "Use lowercase letters, digits, - and _, starting with a letter or digit.";
  }
  return null;
}
